import styled from "styled-components";
import { motion } from "framer-motion";
import {
  MetricLabel,
  MetricSub,
  MetricValue,
  MotionMetricCard,
  PageActions,
  PageContainer,
  PageState as SharedPageState,
  PageTitle,
  PageTopBar,
  Section,
  SectionTitle,
  TableWrapper as SharedTableWrapper,
  TabButton,
  Tabs as SharedTabs,
} from "../../styles/shared";

export const Wrapper = styled(PageContainer)``;

export const PageState = styled(SharedPageState)``;

export const TopBar = styled(PageTopBar)``;

export const Titulo = styled(PageTitle)``;

export const TipoButton = styled.button`
  padding: 0;
  border: none;
  background: none;
  color: ${({ theme }) => theme.accent};
  font: inherit;
  font-weight: 700;
  cursor: pointer;
  text-align: left;

  &:hover {
    text-decoration: underline;
  }
`;

export const TopBarAcoes = styled(PageActions)``;

export const FiltroSelect = styled.select`
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.border};
  background: ${({ theme }) => theme.surface};
  color: ${({ theme }) => theme.textPrimary};
  font-size: 13px;
  cursor: pointer;
  outline: none;

  &:focus {
    border-color: ${({ theme }) => theme.accent};
  }
`;

export const Abas = styled(SharedTabs)``;

export const Aba = styled(TabButton)``;

export const Secao = styled(Section)``;

export const SecaoTitulo = styled(SectionTitle)``;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 220px), 1fr));
  gap: 12px;
`;

export const CardWrapper = styled(MotionMetricCard)``;

export const CardLabel = styled(MetricLabel)``;

export const CardValor = styled(MetricValue)``;

export const CardSub = styled(MetricSub)``;

export const TabelaWrapper = styled(SharedTableWrapper)``;

export const Tabela = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  min-width: 920px;
`;

export const Th = styled.th`
  /* Bugfix #13 (2026-05-29): sticky header amplo. */
  position: sticky;
  top: var(--app-header-height, 0px);
  z-index: 5;
  padding: 11px 14px;
  text-align: left;
  background: ${({ theme }) => theme.surfaceAlt};
  color: ${({ theme }) => theme.textSecondary};
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 1px solid ${({ theme }) => theme.border};
  white-space: nowrap;
`;

export const Tr = styled(motion.tr).attrs(({ $delay }) => ({
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  transition: { delay: $delay },
}))``;

export const Td = styled.td`
  padding: 10px 14px;
  border-bottom: 1px solid ${({ theme }) => theme.border};
  color: ${({ theme }) => theme.textPrimary};
  white-space: nowrap;
`;

export const TdBar = styled(Td)`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 140px;
`;

export const BarraInline = styled.div`
  height: 8px;
  border-radius: 999px;
  background: ${({ theme, $background }) => $background || theme.accent};
  min-width: 4px;
  width: ${({ $width = "0%" }) => $width};
  transition: width 0.5s ease;
`;

export const ClasseBadge = styled.span`
  display: inline-block;
  padding: 2px 10px;
  border-radius: 999px;
  font-weight: 700;
  font-size: 12px;
  color: ${({ $cor }) => $cor};
  background: ${({ $bg }) => $bg};
`;

export const AcumBadge = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: ${({ $classe }) =>
    $classe === "A" ? "var(--success-text)" : $classe === "B" ? "var(--warning-text)" : "var(--danger-text)"};
`;

export const LegendaABC = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
`;

export const LegendaItem = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: ${({ $cor }) => $cor};
  background: ${({ $bg }) => $bg};
  padding: 4px 10px;
  border-radius: 6px;
  font-weight: 600;
`;

export const ResumoABC = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const ResumoCard = styled.div`
  background: ${({ $bg }) => $bg};
  border: 1px solid ${({ $cor }) => `${$cor}44`};
  border-radius: 10px;
  padding: 16px;
`;

export const ResumoClasse = styled.div`
  font-size: 15px;
  font-weight: 700;
  color: ${({ $cor }) => $cor};
  margin-bottom: 8px;
`;

export const ResumoInfo = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.textSecondary};
  margin-bottom: 2px;
`;

export const ResumoReceita = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: ${({ theme }) => theme.textPrimary};
  margin-top: 8px;
  overflow-wrap: anywhere;
`;

export const ModalOverlay = styled(motion.div)`
  position: fixed;
  inset: 0;
  z-index: 220;
  background: rgba(15, 15, 20, 0.58);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

export const ModalCard = styled(motion.div)`
  width: min(1100px, 100%);
  max-height: min(82vh, 860px);
  background: ${({ theme }) => theme.surface};
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: 18px;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.24);
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 18px 20px;
  border-bottom: 1px solid ${({ theme }) => theme.border};
`;

export const ModalTitle = styled.h3`
  font-size: 20px;
  font-weight: 700;
  color: ${({ theme }) => theme.textPrimary};
`;

export const ModalMeta = styled.div`
  margin-top: 4px;
  font-size: 13px;
  color: ${({ theme }) => theme.textSecondary};
`;

export const ModalCloseButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  border: 1px solid ${({ theme }) => theme.border};
  background: ${({ theme }) => theme.surfaceAlt};
  color: ${({ theme }) => theme.textSecondary};
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.textPrimary};
    border-color: ${({ theme }) => theme.accent};
  }
`;

export const ModalTableWrapper = styled(SharedTableWrapper)`
  border: none;
  border-radius: 0;
  flex: 1;
`;

export const ModalTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  min-width: 760px;
`;
